import { supabase } from '@/lib/supabaseClient';

// tenants.time_zone: automation task due dates are local midnight in it (joules-admin-backend
// _task_due). Changed only through set_account_time_zone, which requires an admin.
export const accountTimeZoneService = {
  async get(tenantId: string): Promise<string> {
    const { data, error } = await supabase
      .from('tenants')
      .select('time_zone')
      .eq('tenant_id', tenantId)
      .single();

    if (error) {
      console.error('Failed to load account time zone:', error);
      throw new Error('Unable to load the account time zone.');
    }

    return (data as { time_zone?: string } | null)?.time_zone || 'UTC';
  },

  async set(tenantId: string, timeZone: string): Promise<string> {
    const { error } = await supabase.rpc('set_account_time_zone', {
      p_tenant_id: tenantId,
      p_time_zone: timeZone,
    });

    if (error) {
      console.error('Failed to set account time zone:', error);
      throw new Error(error.message || 'Unable to change the account time zone.');
    }

    return this.get(tenantId);
  },
};
